import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { HdsAlert } from '@hashicorp/design-system-components/components';
import { terraformDeploymentUrl } from 'core/helpers';
import { GEOS } from 'core/utils/constants';

/**
 *
 * `HcpAlertTerraformWorkspaces` is a alert template that renders
 * a link to the geo deployment of Terraform.
 *
 *
 * ```
 * <Hcp::Alert::TerraformUnification />
 * ```
 *
 * @class HcpAlertTerraformWorkspaces
 *
 */
export default class HcpAlertTerraformWorkspaces extends Component {
  @service config;

  get deployGeo() {
    return this.config?.app?.deployGeo ?? GEOS.US;
  }
  <template>
    <HdsAlert
      @type="compact"
      @color="neutral"
      data-test-projects-terraform-workspaces-alert
      as |A|
    >
      <A.Description>
        {{t
          "components.hcp.alert.terraform-workspaces.have-access-explore-workspaces"
          href=(terraformDeploymentUrl this.deployGeo)
          htmlSafe=true
        }}
      </A.Description>
    </HdsAlert>
  </template>
}
